import React, { useState, useMemo } from 'react';
import _ from 'lodash';
import { Box, makeStyles } from '@material-ui/core';
import Available from '../PopWindows/Available';
import AvaliableUnavaliableTbc from '../PopWindows/AvaliableUnavaliableTbc';
import Canceldischarge from '../PopWindows/Canceldischarge';
import Occupieddischarge from '../PopWindows/Occupieddischarge';
import TbcAvailable from '../PopWindows/TbcAvailable';
import bs, { bedP, missingStatus, remarkP, statusP } from '../../bsApp';
import { classNames, getArrayRandomKey, onKeyUpEnterOrSpace } from '../../../../utils';
import StatusIcon from '../../newComponents/Icons/StatusBed';
import useCheckLogin from '../../../../utils/useCheckLogin';
import { MdroIcon } from '../../../../components/MdroInfo';
import { handleNewRemarks, isNotEmptyArray, showNeatsIcon } from '../../../../utils/newBedStatusUtil';
import { CmsAlertStandardIcon } from '../../../../components/Icon';
import RemaksIcon from './RemaksIcon';

// Style components
const useStyles = makeStyles(() => ({
  root: ({ cursor, hasCmsAlerts }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: cursor,
    position: 'relative',
    zIndex: hasCmsAlerts ? 2 : 'auto',
  }),
  top: ({ absolute, isAbsolute }) => ({
    maxWidth: '2.188rem',
    maxHeight: '2.188rem',
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap-reverse',
    position: absolute,
    top: isAbsolute ? 'unset' : '-0.1rem',
    bottom: isAbsolute ? '3.2rem' : 'unset',
  }),
  horizontal: ({ absolute }) => ({
    maxWidth: '1.25rem',
    display: 'flex',
    flexDirection: 'column',
    position: absolute,
    top: '-0.625rem',
    '& > div:nth-child(n-2)': {
      marginBottom: '0.125rem',
    },
  }),
  horizontal_left: ({ isAbsolute }) => ({
    left: 0,
    transform: 'unset',
    zIndex: 1,
  }),
  horizontal_right: ({ isAbsolute }) => ({
    right: 0,
    transform: isAbsolute ? 'unset' : 'translateX(100%)',
    alignItems: 'flex-end',
    zIndex: 1,
  }),
  cmsAlert: {
    width: '1.85rem',
    height: '1.6rem',
    marginTop: '-0.2rem',
  },
}));

// Logic component that Control position of remarks
// 控制角标的显示位置
const positionRemaks = (remarks) => {
  const filter = (filterRemaks) => {
    // filterRemaks stand for which icon you wanna show
    const result = [];
    _.forEach(remarks, (item) => {
      // 如果api返回的字段跟top里面的icon对的上，就返回对应的icon
      if (filterRemaks.hasOwnProperty(item)) {
        // if top icon container have a key that remarks(array) have too, then show icon correspondingly(by push it into a new array)
        result.push(<RemaksIcon key={item} typeName={item} />);
      }
    });
    return result;
  };

  return {
    top: () => {
      // top 可能展示的所有标签
      const topRemaks = {
        [bs.AIRBORNE_PRECAUTION]: 1, // if the items of this object include the bed status item, then push the icon to array to show on page
        [bs.DROPLET_PRECAUTION]: 1,
        [bs.CONTACT_PRECAUTION]: 1,
        [bs.REVERSE_LSOLATION]: 1,
      };
      return filter(topRemaks);
    },
    left: () => {
      const leftRemaks = {
        [bs.ATTENTION]: 1,
        [bs.DISCHARGING]: 1,
        [bs.DAY_BED]: 1,
        [bs.ADDED_BED]: 1,
        [bs.FROZEN]: 1,
        [bs.ELDERLY_HOME]: 1,
      };
      return filter(leftRemaks);
    },
    right: () => {
      const rightRemaks = {
        [bs.BASIC_CLEANSING]: 1,
        [bs.BASIC_CLEANSING_ONGOING]: 1,
        [bs.TERMINAL_DISINFECTION]: 1,
        [bs.TERMINAL_DISINFECTION_ONGOING]: 1,
        [bs.PENDING_ADMISSION]: 1,
        [bs.RESUSITATION]: 1,
        [bs.MAINTANIENCE]: 1,
        [bs.LIFE_SAVING_EQUIPMENT]: 1,
        [bs.NEATS]: 1,
        [bs.COVID_19]: 1,
        [bs.HOME_LEAVE]: 1,
        [bs.HOME_LEAVE_OVERTIME]: 1,
        [bs.RETURN_DAY_CASE]: 1,
        [bs.TO]: 1,
      };
      return filter(rightRemaks);
    },
  };
};

// Main component
export default function BedStatusIcon({
  id,
  isAbsolute,
  allData,
  disabled,
  updateBedStatus,
  saveBedStatus,
  saveReturnDayCase,
  ward,
  editFloorPlan = false,
  reload,
  isMutipleWardCode,
}) {
  // 把api返回字段和本地字段进行对应
  const status = useMemo(() => {
    if (editFloorPlan) {
      return allData?.[bedP.status] === bs.UNAVAILABLE ? bs.UNAVAILABLE : bs.TBC;
    }

    // 病床基本状态 -> 对应api的status字段
    const missing = allData?.[bedP.missingStatus];
    if (missing === missingStatus.missing) {
      return statusP.MISSING;
    } else if (missing === missingStatus.missingClose) {
      return statusP.MISSING_CLOSED;
    } else {
      return allData?.[bedP.status];
    }
  }, [allData, editFloorPlan]);
  const gender = allData?.patGender; // 病人的性别 -> 对应api的patGender字段
  const bedNo = allData?.bedNo; // 病人的床号 -> 对应api的bedNo字段
  const checkLogin = useCheckLogin();

  const handleUnavailableRemark = (newRarks) => {
    if (status !== bs.UNAVAILABLE) {
      if (allData?.[bedP.airbornePrecaution]) {
        newRarks.push(remarkP.AIRBORNE_PRECAUTION);
      }
      if (allData?.[bedP.dropletPrecaution]) {
        newRarks.push(remarkP.DROPLET_PRECAUTION);
      }
      if (allData?.[bedP.contactPrecaution]) {
        newRarks.push(remarkP.CONTACT_PRECAUTION);
      }
    }
  };

  const handleEditModeReturnRemarks = (newRarks) =>
    _.filter(newRarks, (item) => {
      if (status === bs.TBC) {
        return item === remarkP.DAY_BED || item === remarkP.ADDED_BED;
      } else {
        return (
          item === remarkP.MAINTANIENCE ||
          item === remarkP.RESUSITATION ||
          item === remarkP.LIFE_SAVING_EQUIPMENT ||
          item === remarkP.DAY_BED ||
          item === remarkP.ADDED_BED ||
          item === remarkP.FROZEN
        );
      }
    });

  // 病床的其他状态 -> api的剩余字段
  const newRemarks = useMemo(() => {
    const newRarks = [];
    if (showNeatsIcon(allData)) {
      newRarks.push(remarkP.NEATS);
    }
    if (allData?.[bedP.bedCleaning] === 'B') {
      newRarks.push(allData?.[bedP.proceedCleansing] === 1 ? remarkP.BASIC_CLEANSING_ONGOING : remarkP.BASIC_CLEANSING);
    }
    if (allData?.[bedP.bedCleaning] === 'TD') {
      newRarks.push(
        allData?.[bedP.proceedCleansing] === 1 ? remarkP.TERMINAL_DISINFECTION_ONGOING : remarkP.TERMINAL_DISINFECTION
      );
    }
    if (allData?.[bedP.returnDayCase] === 'Y') {
      newRarks.push(remarkP.RETURN_DAY_CASE);
    } else if (allData?.[bedP.forClinicalAdmission] || allData?.[bedP.transferInRequestInfo]) {
      newRarks.push(remarkP.PENDING_ADMISSION);
    }

    if (allData?.[bedP.resuscitation]) {
      newRarks.push(remarkP.RESUSITATION);
    }
    if (allData?.[bedP.maintenance]) {
      newRarks.push(remarkP.MAINTANIENCE);
    }
    if (allData?.[bedP.lifeSavingEquipment]) {
      newRarks.push(remarkP.LIFE_SAVING_EQUIPMENT);
    }
    if (allData?.[bedP.attention]) {
      newRarks.push(remarkP.ATTENTION);
    }
    // 新加的elder home icon
    if (allData?.[bedP.elderlyHome]) {
      newRarks.push(remarkP.ELDERLY_HOME);
    }
    handleNewRemarks(allData, newRarks);

    handleUnavailableRemark(newRarks);

    if (editFloorPlan) {
      return handleEditModeReturnRemarks(newRarks);
    } else {
      return [...newRarks, allData?.status]; // this method return an array to save local bed status and join with remote bed status
    }
  }, [allData, editFloorPlan, status, handleNewRemarks]); // 合并  ->  所有api返回字段的对应remark字符串

  const classes = useStyles({
    absolute: isAbsolute ? 'absolute' : 'relative',
    cursor: disabled ? 'unset' : 'pointer',
    isAbsolute: isAbsolute,
    hasCmsAlerts: isNotEmptyArray(allData?.[bedP?.cmsAlertInfos]),
  });
  const [IsPop, setIsPop] = useState(false);
  const closePop = () => {
    setIsPop(false);
  };
  const openPop = () => {
    if (checkLogin()) {
      !disabled && setIsPop(true);
    }
  };

  // 把本地定义的字段跟弹框进行对应
  const bedPop = {
    [bs.OCCUPIED]: Occupieddischarge,
    [bs.UNAVAILABLE]: Available,
    [bs.AVAILABLE]: AvaliableUnavaliableTbc,
    [bs.TBC]: TbcAvailable,
    [bs.DISCHARGING]: Canceldischarge,
    [bs.MISSING]: Occupieddischarge,
    [bs.MISSING_CLOSED]: Occupieddischarge,
  };

  // 控制弹框是否显示
  const showPop = () => {
    let Pop = bedPop[allData?.[bedP.status]];
    return Pop ? (
      <Pop
        updateBedStatus={updateBedStatus}
        open={IsPop}
        closePop={closePop}
        allData={allData}
        saveBedStatus={saveBedStatus}
        saveReturnDayCase={saveReturnDayCase}
        reload={reload}
      />
    ) : (
      <div />
    );
  };

  const lefts = positionRemaks(newRemarks).left();
  const rights = positionRemaks(newRemarks).right();

  const contentBox = () => {
    return (
      <>
        <div
          className={classes.top}
          style={
            isAbsolute
              ? null
              : { marginLeft: lefts?.length ? '1.25rem' : 0, marginRight: rights?.length ? '1.25rem' : 0 }
          }
        >
          {positionRemaks(newRemarks).top()}
        </div>
        <Box display="flex">
          <div className={isAbsolute ? classNames(classes.horizontal, classes.horizontal_left) : classes.horizontal}>
            <Box style={{ transform: isAbsolute ? 'translateX(10px)' : 'unset' }}>{lefts}</Box>
          </div>
          <StatusIcon
            typeName={status}
            genderType={gender}
            bedNo={bedNo}
            ward={ward}
            linkedBedNo={allData.linkedBedNo}
            linkeds={allData.linkeds}
            linkedId={allData.linkedId}
            bedHead={allData.bedHead}
            editFloorPlan={editFloorPlan}
            newRemarks={newRemarks}
            allData={allData}
            isMutipleWardCode={isMutipleWardCode}
          />
          <div className={isAbsolute ? classNames(classes.horizontal, classes.horizontal_right) : classes.horizontal}>
            {rights}
            <Box style={{ transform: isAbsolute ? 'translateX(10px)' : 'unset' }}>
              {_.map(_.orderBy(allData?.[bedP.mdroInfo], ['alertDesc'], ['asc']), (item, index) => (
                <MdroIcon
                  value={item.alertDesc}
                  confirmedInd={item.confirmedInd}
                  width="2.2rem"
                  height="0.8rem"
                  fontSize="0.5rem"
                  type="bedstatus"
                  key={getArrayRandomKey(index, `mdro-icon-${item.rowkey}`)}
                />
              ))}
              {isNotEmptyArray(allData?.[bedP?.cmsAlertInfos]) && <CmsAlertStandardIcon className={classes.cmsAlert} />}
            </Box>
          </div>
        </Box>
      </>
    );
  };

  return (
    <>
      <div
        id={id}
        className={classes.root}
        onClick={openPop}
        style={isAbsolute ? null : { marginBottom: rights?.length > 2 || lefts?.length > 2 ? '-1.25rem' : 0 }}
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, openPop)}
      >
        {contentBox()}
      </div>
      {IsPop ? showPop() : ''}
    </>
  );
}
